import React, { useEffect } from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Slide, SlideProps, Snackbar } from '@mui/material';
import Alert from '@mui/material/Alert';

type TransitionProps = Omit<SlideProps, 'direction'>;
interface UiSnackbarAlertPropsType {
    open: boolean;
    handleClose?: any;
    message: string;
    actionButtonMessage?: string;
    closeMessage?: string;
    severity?: 'success' | 'info' | 'warning' | 'error' | undefined;
}
function TransitionLeft(props: TransitionProps) {
    return <Slide {...props} direction="left" />;
  }
export default function UiSnackbarAlert(
    {
        open,
        handleClose,
        message,
        actionButtonMessage,
        closeMessage,
        severity
    } :UiSnackbarAlertPropsType
){      
    const [transition, setTransition] = React.useState<
    React.ComponentType<TransitionProps> | undefined>(undefined);
        return(
            <Snackbar
                open={open}
                onClose={handleClose}
                TransitionComponent={TransitionLeft}
                message={message}
                key={transition ? transition.name : ''}
                className="error-snackbar"
            >
                 <Alert onClose={handleClose} severity="error">
                        {message}
                    </Alert>
                </Snackbar>
        )
}